import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';
import './styles.css';

class VirtualVisitUrl extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    visit: PropTypes.object,
  };

  addProtocol = (visitUrl) => {
    if (!visitUrl || visitUrl.match(/:\/\//)) return visitUrl;
    return `https://${visitUrl}`;
  };

  renderLocationSeparator = (hasLocation) =>
    hasLocation && <span className="virtual-url">; </span>;

  renderVirtualLink = (virtualUrlHidden, virtualUrl) =>
    !virtualUrlHidden && (
      <a
        data-cy="virtual-visit-url-link"
        className="virtual-url"
        href={this.addProtocol(virtualUrl)}
        target="_blank"
        rel="nofollow external noopener noreferrer"
      >
        <FormattedMessage {...messages.virtualUrl} />
      </a>
    );

  renderWarning = (virtualUrlHidden) =>
    virtualUrlHidden && (
      <span data-cy="virtual-visit-url-warning" className="hidden-warning virtual-url">
        <FormattedMessage {...messages.virtualWarning} />
      </span>
    );

  render() {
    const {
      visit: { location, virtualUrl, virtualUrlHidden },
    } = this.props;
    if (!virtualUrl && !virtualUrlHidden) return null;
    return (
      <React.Fragment>
        {this.renderLocationSeparator(!!location)}
        {this.renderVirtualLink(virtualUrlHidden, virtualUrl)}
        {this.renderWarning(virtualUrlHidden)}
      </React.Fragment>
    );
  }
}

export default injectIntl(VirtualVisitUrl);
